export const getColorByCount = (
  count = 0,
  listColor = [
    "rgba(255, 99, 132, 1)",
    "rgba(255, 159, 64, 1)",
    "rgba(255, 205, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(201, 203, 207, 1)",
  ]
) => {
  if (!count) return [];
  if (count <= listColor.length) return listColor.slice(0, count);
  return getColorByCount(count, listColor.concat(listColor));
};
